// extracted by mini-css-extract-plugin
module.exports = {"ocbWrapper":"styles_ocbWrapper__fFRvi","dcButton":"styles_dcButton__te_mJ","catalogButton":"styles_catalogButton__RHTy4"};